import React from "react";
import DatePickerInner from './DatePickerInner';
import moment from 'moment';

export default class MyDatePicker extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            value: new Date()
        }
    }

    componentDidMount(){
        this.setState({value: Date.parse(this.props.value)});
    }

    handleChange(event) {
        this.setState({value: event.target.value});
        if (this.props.onChange)
            this.props.onChange(event.target.value)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
          this.setState({value: this.props.value})
        }
      }

    getDate(){
        return this.state.value;
    }

    render (){

        const passwordFlag = this.props.type != undefined ? this.props.type == "password" : false;

        return ( 
        <div style={mainClass}>
            <div style={name}>{this.props.name}</div>
            <DatePickerInner readOnly={this.props.readOnly ? this.props.readOnly : false} style={inputText} selected={this.state.value} onChange={date => {
                if (this.props.onChange != undefined)
                    this.props.onChange(moment(date).format("DD-MM-yyyy")); 
                this.setState({value: date})}
             } />
        </div>
        )
    }
}

const mainClass = {
    padding: '5px',
}

const name = {
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}